import React from "react";
import NotesIcon from "@mui/icons-material/Notes";
import { Container, RightContainer, Title } from "./styled";
import { useSelector } from "react-redux";
import moment from "moment";

const DataEntregaResult = () => {
  const thisCard = useSelector((state) => state.card);

  const formattedDate = thisCard.dateEntrega
    ? moment.utc(thisCard.dateEntrega).isValid()
      ? moment.utc(thisCard.dateEntrega).format("DD/MM/YYYY")
      : "-"
    : "";

  return (
    <Container>
      <NotesIcon fontSize="small" />
      <RightContainer>
        <Title>Data Entrega</Title>
        <p>{formattedDate}</p>
      </RightContainer>
    </Container>
  );
};

export default DataEntregaResult;
